var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarCampaignsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_666_12034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 7.20834V8.53334L10.775 13.35C10.2917 13.6 9.70833 13.6 9.225 13.35L0 8.53334V7.20834C0 6.51667 0.383333 5.88334 0.991667 5.55834L9.11667 1.21667C9.66667 0.925008 10.3333 0.925008 10.8833 1.21667L19.0083 5.55834C19.6167 5.88334 20 6.51667 20 7.20834Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.29167C17.5 1.02583 16.4742 0 15.2083 0H4.79167C3.52583 0 2.5 1.02583 2.5 2.29167V16.725C2.5 17.07 2.78 17.35 3.125 17.35H16.875C17.22 17.35 17.5 17.07 17.5 16.725V2.29167Z",
    fill: "#ECEFF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 8.53333V17.2917C20 18.325 19.1583 19.1667 18.125 19.1667H1.875C0.841667 19.1667 0 18.325 0 17.2917V8.53333L9.225 13.35C9.70833 13.6 10.2917 13.6 10.775 13.35L20 8.53333Z",
    fill: "#64B5F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.54199 10.2292C7.50866 10.2292 6.66699 9.38834 6.66699 8.35417C6.66699 7.6975 7.01283 7.0875 7.56949 6.76417C7.86783 6.59084 8.25033 6.6925 8.42366 6.99C8.59699 7.28834 8.49616 7.67084 8.19783 7.84417C8.02199 7.94667 7.91699 8.1375 7.91699 8.35417C7.91699 8.69917 8.19783 8.97917 8.54199 8.97917C8.88616 8.97917 9.16699 8.69834 9.16699 8.35417C9.16699 8.265 9.14949 8.18834 9.11449 8.12167C8.95366 7.81667 9.06949 7.43834 9.37449 7.27667C9.67866 7.11417 10.057 7.23167 10.2195 7.53667C10.3503 7.785 10.417 8.06 10.417 8.35417C10.417 9.38834 9.57533 10.2292 8.54199 10.2292Z",
    fill: "#FF9800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 9.83252C14.3167 9.83252 14.2567 9.82419 14.1992 9.80752L5.44917 7.24585C5.18333 7.16752 5 6.92335 5 6.64585V5.39585C5 5.11669 5.185 4.87169 5.45333 4.79502L14.2033 2.29502C14.3908 2.24252 14.5958 2.27835 14.7508 2.39752C14.9083 2.51502 15 2.70002 15 2.89585V9.20752C15 9.40419 14.9075 9.58919 14.7492 9.70752C14.64 9.79002 14.5083 9.83252 14.375 9.83252Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.375 10.1875C14.03 10.1875 13.75 9.90752 13.75 9.56252V2.47919C13.75 2.13419 14.03 1.85419 14.375 1.85419C14.72 1.85419 15 2.13419 15 2.47919V9.56252C15 9.90752 14.72 10.1875 14.375 10.1875Z",
    fill: "#FFB300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.625 7.68752C5.28 7.68752 5 7.40752 5 7.06252V4.97919C5 4.63419 5.28 4.35419 5.625 4.35419C5.97 4.35419 6.25 4.63419 6.25 4.97919V7.06252C6.25 7.40752 5.97 7.68752 5.625 7.68752Z",
    fill: "#FFB300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_666_12034"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarCampaignsIcon);
export default __webpack_public_path__ + "static/media/SidebarCampaignsIcon.6b8d5712fa7ef2f6789c4bcba4a433d9.svg";
export { ForwardRef as ReactComponent };